import { type GenerationFailureReason as FailureReason, GenerationFailureReason } from "@storyline/shared";
import type { PillTone } from "@/src/common/components/pill";
import { FrameStatus } from "@/src/stories/utils/frame-state";

export const FRAME_STATUS_LABELS: Record<FrameStatus, string> = {
	[FrameStatus.GENERATED]: "Générée",
	[FrameStatus.INHERITED]: "Héritée du plan précédent",
	[FrameStatus.NOT_REQUIRED]: "Non requise",
	[FrameStatus.PENDING]: "En attente",
	[FrameStatus.FAILED]: "Échec",
};

export const FRAME_STATUS_TONES: Record<FrameStatus, PillTone> = {
	[FrameStatus.GENERATED]: "success",
	[FrameStatus.INHERITED]: "accent",
	[FrameStatus.NOT_REQUIRED]: "neutral",
	[FrameStatus.PENDING]: "warning",
	[FrameStatus.FAILED]: "danger",
};

export type FailureReasonDetail = {
	description: string;
	serverAction: string;
};

export const FAILURE_REASON_DETAILS: Record<FailureReason, FailureReasonDetail> = {
	[GenerationFailureReason.IDENTITY_DRIFT]: {
		description: "Le personnage ne ressemble plus à sa référence.",
		serverAction: "Renforce les références d'identité du personnage.",
	},
	[GenerationFailureReason.ENVIRONMENT_DRIFT]: {
		description: "Le décor ne correspond plus au lieu.",
		serverAction: "Réinjecte le plan maître du lieu et sa clause décor.",
	},
	[GenerationFailureReason.POV_FAILURE]: {
		description: "La caméra n'est plus subjective ou le héros apparaît.",
		serverAction: "Renforce les clauses de caméra POV.",
	},
	[GenerationFailureReason.ACTION_FAILURE]: {
		description: "L'action demandée n'est pas visible.",
		serverAction: "Simplifie le prompt pour clarifier l'action.",
	},
	[GenerationFailureReason.TRANSITION_FAILURE]: {
		description: "La continuité avec le plan précédent est cassée.",
		serverAction: "Repart d'une frame canonique indépendante.",
	},
	[GenerationFailureReason.VISUAL_ARTIFACT]: {
		description: "Membres difformes, texte illisible ou glitch.",
		serverAction: "Change de seed et régénère.",
	},
	[GenerationFailureReason.PROVIDER_ERROR]: {
		description: "Échec technique du fournisseur.",
		serverAction: "Réessaie la génération telle quelle.",
	},
};
